import dateSelection from './dateSelection';
import getHoursInRange from '@/logic/helpers/dates/getHoursInRange';

const directUser = {
  calRef: undefined as unknown | any,

  goFromCalendarToCertainView(e: { target: any }): void {
    const calRef = directUser.calRef;

    const isCalDay =
      e.target.classList.contains('day') || e.target.parentNode.classList.contains('day');
    const dayWithDeadline =
      e.target.hasAttribute('data-is-busy') || e.target.parentNode.hasAttribute('data-is-busy');

    const numberOfDeadlinesThisDay = calRef.extractInfoFromElementAttribute(
      e,
      'title',
      (operationTarget: string) => operationTarget.split('').pop(),
      'number',
    );

    if (isCalDay) {
      let day;

      if (e.target.classList.contains('day')) day = e.target.querySelector('span').innerText;
      else day = e.target.innerText;

      const clickFromHome =
        calRef.$route.path === '/assessor-tasks' || calRef.$route.path === '/client-tasks';
      const pureCalendar = calRef.$route.query.pureCalendar === 'true';
      const readOnlyCalendar = clickFromHome || pureCalendar;
      const date = calRef.getDateWithRequiredFormat(calRef.getPickedDate(day));

      const canOpenProjectsModalForClient =
        calRef.userRole === 'client' && dayWithDeadline && numberOfDeadlinesThisDay === 1;

      const assessmentToPassToModal = calRef.extractInfoFromElementAttribute(
        e,
        'project',
        (operationTarget: string) => operationTarget.split(':'),
      );

      const multipleDeadlinesThisDayForClient =
        calRef.userRole === 'client' && dayWithDeadline && numberOfDeadlinesThisDay > 1;

      if (
        readOnlyCalendar &&
        !calRef.isInModal &&
        (calRef.userRole === 'assessor' || multipleDeadlinesThisDayForClient)
      ) {
        calRef.router.push({
          path: '/events-for-day',
          query: { date: date, fetchDeadlines: 'true' },
        });
      } else if (readOnlyCalendar && canOpenProjectsModalForClient) {
        calRef.$emit('clickOnADayWithDeadline', ...assessmentToPassToModal, true);
      } else {
        if (calRef.userRole === 'assessor' && !calRef.isInModal) {
          calRef.router.push({
            path: '/assessor-assessment-select-hour',
            query: {
              cand: calRef.candidate,
              candID: calRef.candidateId,
              comp: calRef.company,
              pic: calRef.profilePic,
              pos: calRef.position,
              assessmentID: calRef.assessmentId,
              date: date,
            },
          });
        } else if (calRef.userRole === 'assessor' && calRef.isInModal) {
          dateSelection.selectSingleDate(e);
          calRef.$emit('dateSelected', date.concat('T12:00'));
        }
      }
    }
  },

  goDirectlyToAssessmentPlaceWithMultipleDates(self: Record<string, any>): void {
    const hoursInRange = getHoursInRange(self.hoursBottomRange, self.hoursTopRange);

    // Prepare dates to pass to the Backend. 'T' added to prevent Safari bugs.
    const datesToPass: string[] = self.selectedDates.flatMap((date: unknown) =>
      hoursInRange.map((hour) => new Date(`${date}T${hour}`).toJSON()),
    );

    if (self.device === 'mobile' || !self.isInModal) {
      self.router.push({
        path: '/assessment-place',
        query: {
          cand: self.candidate,
          comp: self.company,
          pic: self.profilePic,
          pos: self.position,
          assessmentID: self.assessmentId,
          dateTime: (datesToPass as unknown) as string,
        },
      });
    }

    if (self.isInModal) self.$emit('multipleDatesPicked', datesToPass);
  },
};

export default directUser;
